/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
var Trigger = (function () {
    function Trigger(open, close) {
        this.open = open;
        this.close = close || open;
    }
    Trigger.prototype.isManual = function () {
        return this.open === 'manual' || this.close === 'manual';
    };
    return Trigger;
}());
export { Trigger };
//# sourceMappingURL=trigger.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/utils/trigger.class.js
// module id = 205
// module chunks = 10